export default {"src":"/_next/static/media/paypal.68e13fa3.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};